"use client"

import { TestTubeDiagonal } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `TestTubeDiagonalIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const TestTubeDiagonalIcon = component(Icon)({ as: TestTubeDiagonal })
